export default __webpack_public_path__ + "media/tests/test_vya-030b88df.png";